export enum SelectiveTargetingOptionValues {
  ALL_MOBILE_APPS = 'all_mobile_apps',
  ALL_WEBSITES = 'all_websites',
  EVERYTHING = 'everything',
  CUSTOM = 'custom',
  OTT = 'OTT',
}
